export default "__VITE_ASSET__HTGym8uu__"